import { Controller } from "@hotwired/stimulus"

// Clicks its element from an action (a shortcut: keydown.meta+k@document->click#click:prevent),
// or, given a target, clicks that element as soon as it connects.
export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    if (!this.hasTargetValue) return

    document.getElementById(this.targetValue).click()
    history.replaceState({}, "", window.location.pathname)
  }

  click() {
    this.element.click()
  }
}
